<div class="container" cdkDropList cdkDropListSortingDisabled="true" [cdkDropListEnterPredicate]="noReturnPredicate">
  <!-- (cdkDropListExited)="dragExit(true)" (cdkDropListEntered)="dragEnter(false)" -->
  <div class="menu" [ngClass]="{inPopup:isInFollowUpQuestionPopup}" *ngIf="types$ | async as types">
    <div class="warpH5 pointer" (click)="openWords()">
      <img src="/assets/images/types/dropdown.svg" class="dropdown-img" *ngIf="this.WordsOpen" />
      <img src="/assets/images/types/dropdown-close.svg" class="dropdown-img scale-img" *ngIf="!this.WordsOpen" />
      <h5 class="bold_txt" translate>menuTypes.titleWord</h5>
    </div>

    <div *ngIf="WordsOpen">
      <ng-container *ngIf="!loading$() else loading">
        <div *ngFor="let type of types.texts">
          <div class="item" cdkDrag cdkDragPreviewClass="selected" [cdkDragData]="type" (click)="isInFollowUpQuestionPopup?addItemToBoard(type):null">

            <div class="inner-item">
              <div class="drag-img"  *ngIf="!isInFollowUpQuestionPopup">
                <img class="back-img" src="/assets/images/menu_types_selected.svg">
              </div>
              <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
              <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
            </div>
            <img src="/assets/images/question-menu/plus.svg" (click)="addItemToBoard(type)" class="add-button" />


            <!-- <div class="item selected" *cdkDragPlaceholder>
              <div class="inner-item">
                <img class="scale-img" src="/assets/images/types/{{type.image}}" />
                <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
              </div>
              <img class="back-img" src="/assets/images/menu_types_selected.svg">
            </div> -->
          </div>

          <div *ngIf="(dragTypeId$ | async)==type.id" class="item selected">
            <div class="inner-item">
              <img class="back-img" src="/assets/images/menu_types_selected.svg">

              <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
              <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
            </div>
          </div>

        </div>
      </ng-container>
    </div>

    <hr class="hr" />

    <div class="warpH5 pointer" (click)="openType()">
      <img src="/assets/images/types/dropdown.svg" class="dropdown-img" *ngIf="this.TypeOpen" />
      <img src="/assets/images/types/dropdown-close.svg" class="dropdown-img scale-img" *ngIf="!this.TypeOpen" />

      <h5 class="bold_txt" translate>menuTypes.titleQuestions</h5>
    </div>

    <div *ngIf="TypeOpen">
      <ng-container *ngIf="!loading$() else loading">
      <div *ngFor="let type of types.questions">
        <div cdkDrag cdkDragPreviewClass="selected" class="item" [cdkDragData]="type"   (click)="isInFollowUpQuestionPopup?addItemToBoard(type):null">
          <div class="inner-item">
            <div class="drag-img" *ngIf="!isInFollowUpQuestionPopup">
              <img class="back-img" src="/assets/images/menu_types_selected.svg">
            </div>

            <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
            <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
          </div>
          <img src="/assets/images/question-menu/plus.svg" (click)="addItemToBoard(type)" class="add-button" />


          <div class="item selected" *cdkDragPlaceholder>
            <div class="inner-item">
              <img class="back-img" src="/assets/images/menu_types_selected.svg">

              <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
              <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
            </div>
          </div>
        </div>
        <div *ngIf="(dragTypeId$ | async)==type.id" class="item selected x">
          <div class="inner-item">
            <img class="back-img" src="/assets/images/menu_types_selected.svg">
            <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
            <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
          </div>
        </div>
      </div>
      </ng-container>
    </div>

    <hr class="hr" />
    <div class="warpH5 pointer" (click)="openButtons()">
      <img src="/assets/images/types/dropdown.svg" class="dropdown-img" *ngIf="this.ButtonOpen" />
      <img src="/assets/images/types/dropdown-close.svg" class="dropdown-img scale-img" *ngIf="!this.ButtonOpen" />
      <h5 class="bold_txt" translate>menuTypes.titleButton</h5>
    </div>
    <div *ngIf="ButtonOpen">
      <ng-container *ngIf="!loading$() else loading">
        <div *ngFor="let type of types.buttons">
          <div class="item" cdkDrag [cdkDragData]="type" cdkDragPreviewClass="selected"  (click)="isInFollowUpQuestionPopup?addItemToBoard(type):null">
            <div class="inner-item">
              <div class="drag-img" *ngIf="!isInFollowUpQuestionPopup">
                <img class="back-img" src="/assets/images/menu_types_selected.svg">
              </div>
              <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
              <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
            </div>
            <img src="/assets/images/question-menu/plus.svg" (click)="addItemToBoard(type)" class="add-button" />


            <!-- <div class="item selected" *cdkDragPlaceholder>
              <div class="inner-item">
                <img class="scale-img" src="/assets/images/types/{{type.image}}" />
                <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
              </div>
              <img class="back-img" src="/assets/images/menu_types_selected.svg">
            </div> -->
          </div>

          <div *ngIf="(dragTypeId$ | async)==type.id" class="item selected">
            <div class="inner-item"> <img class="back-img" src="/assets/images/menu_types_selected.svg">
              <img [ngClass]="getScaleImgClass(type.id)" src="/assets/images/types/{{type.image}}" />
              <p class="txt" translate [translateParams]="{ type: type }">menuTypes.name</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="warp-mini-load">
      <div *ngFor="let _ of [].constructor(3)" class="loading-item load-enimation"></div>
  </div>
</ng-template>